import { useState } from "react"
import PropTypes from "prop-types"
import StepDetails from "./step_details"
import { formatToTimestamp } from "app/components/diy_composer/utils/format_time"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

const AppletDetails = ({ details }) => {
  const [showDetails, setShowDetails] = useState(false)

  const triggerAdded = !!details.applet_trigger
  const queriesAdded = details.applet_queries.length > 0
  const filterCodeAdded = !!details.filter_code
  const actionsAdded = details.applet_actions.length > 0
  const delayAdded = details.normalized_applet.actions_delay > 0

  const formattedDelay = () => {
    return formatToTimestamp(Number(details.normalized_applet.actions_delay))
  }

  const handleShowDetails = () => {
    logIFTTTNextAction("click", {
      object_type: "more_less_detail",
      location_type: "applet_details",
    })

    setShowDetails(!showDetails)
  }

  return (
    <div className="applet-details">
      {showDetails ? (
        <>
          {triggerAdded && (
            <>
              <StepDetails
                label="If"
                brandColor={
                  `#` + details.applet_trigger.trigger.channel.brand_color
                }
                image={
                  details.applet_trigger.trigger.channel.monochrome_image_url
                }
                name={details.applet_trigger.trigger.name}
                serviceName={details.applet_trigger.trigger.channel.name}
              />
            </>
          )}
          {queriesAdded &&
            details.applet_queries.map(query => (
              <>
                <StepDetails
                  label="With"
                  brandColor={`#` + query.query.channel.brand_color}
                  image={query.query.channel.monochrome_image_url}
                  serviceName={query.query.name}
                />
              </>
            ))}
          {filterCodeAdded && (
            <StepDetails
              label="When"
              brandColor="#222222"
              name="Filter code"
              serviceName="Filter code"
            />
          )}
          {delayAdded && (
            <StepDetails
              label="Wait"
              brandColor="#222222"
              name="Delay"
              serviceName={`${formattedDelay()} delay`}
            />
          )}
          {actionsAdded &&
            details.applet_actions.map((action, i) => (
              <>
                <StepDetails
                  label={i > 0 ? "And" : "Then"}
                  brandColor={`#` + action.action.channel.brand_color}
                  image={action.action.channel.monochrome_image_url}
                  name={action.action.name}
                  serviceName={action.action.channel.name}
                  finalStep={details.applet_actions.length === i + 1}
                />
              </>
            ))}
          <a className="txt-body-3" onClick={handleShowDetails}>
            Less detail
          </a>
        </>
      ) : (
        <a className="txt-body-3" onClick={handleShowDetails}>
          More detail
        </a>
      )}
    </div>
  )
}

AppletDetails.propTypes = {
  details: PropTypes.shape({
    applet_actions: PropTypes.arrayOf(PropTypes.object),
    applet_queries: PropTypes.arrayOf(PropTypes.object),
    applet_trigger: PropTypes.object,
    normalized_applet: PropTypes.object,
    filter_code: PropTypes.string,
  }),
}

export default AppletDetails
